import { useEffect, useRef } from "react";
import * as MessageService from "../../../services/MessageService";

/**
 * Subscribes to ChatUpdate + ChatMention and calls:
 *  - onRefresh(silent) when a chat update arrives (debounced)
 *  - onMention(e)      when a mention arrives
 */
export default function UseChatUpdates({ onRefresh, onMention }) {
    const tRef = useRef(null);

    useEffect(() => {
        const idUpdate = "CustomerChatView.ChatUpdate";
        const idMention = "CustomerChatView.ChatMention";

        const handleUpdate = () => {
            if (tRef.current) clearTimeout(tRef.current);
            tRef.current = setTimeout(() => onRefresh?.(true), 200);
        };

        MessageService.Helper.register(idUpdate, MessageService.MessageTypes.ChatUpdate, handleUpdate);
        if (onMention) {
            MessageService.Helper.register(idMention, MessageService.MessageTypes.ChatMention, onMention);
        }

        return () => {
            if (tRef.current) clearTimeout(tRef.current);
            MessageService.Helper.unregister(idUpdate, MessageService.MessageTypes.ChatUpdate);
            if (onMention) {
                MessageService.Helper.unregister(idMention, MessageService.MessageTypes.ChatMention);
            }
        };
    }, [onRefresh, onMention]);
}
